import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'confirm-close-dialog.component',
    templateUrl: 'confirm-close-dialog.component.html',
    styleUrls: ['./confirm-close-dialog.component.scss'],
})
export class ConfirmCloseDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<ConfirmCloseDialogComponent>,
    ) {}
    clickRemove() {
        this.dialogRef.close('OK');
    }
}
